import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { EmsServicesService } from 'src/app/module/ems-master/services/ems-services.service';
import { SharedService } from 'src/app/shared/shared.service';
import { BudgetsService } from '../../services/budgets.service';
import { DatePipe } from '@angular/common';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { createQuickCodeComponent } from 'src/app/module/ems-master/component/quick-code/create-quick-code/create-quick-code.component';
import { NgSelectComponent } from '@ng-select/ng-select';
import * as moment from 'moment';

@Component({
  selector: 'app-add-budget',
  templateUrl: './add-budget.component.html',
  styleUrls: ['./add-budget.component.css']
})
export class AddBudgetComponent {
  date: Date = new Date() ;
  date2: Date = new Date();
  createForm = new FormGroup({
    financialYearId: new FormControl(null),
    budgetDate: new FormControl(),
    warehouseId: new FormControl(null, Validators.required),
    // zoneId: new FormControl(null, Validators.required),
    accountId: new FormControl(null, Validators.required),
    mappingId: new FormControl(null, Validators.required),
    // customerOwned:new FormControl(null, Validators.required),
    // totalExpenseAmount: new FormControl(null, Validators.required),
    approvedBudget: new FormControl(null, Validators.required),
    budgetTypeId: new FormControl(null, Validators.required),
    referenceId: new FormControl(null, Validators.required),
    remarks: new FormControl(null),
    // warehouseTypeId: new FormControl(null, Validators.required),
    budgetProof: new FormControl (null),
    budgetProofFile: new FormControl (null),
    expenseId:  new FormControl(null, Validators.required),
  })

  warehouseList: any;
  getWarehouseList: any;
  zone: any;
  accountList: any;
  accountMappingList:any;
  expenseAssociated: any;
  budgetType: any;
  financialYear: any;
  referenceList: any;
  warehouseTypeList: any;
  editTrue: boolean = true;
  EditData: any;
  selectedFiles:any;
  progress = 0
  currentFile:any;
  message:any;
  @ViewChild('uploadInput') uploadInput!: ElementRef;
  allCatagory: any;
  sendCatagoryId: (number | undefined)[];
  expenseTypeList: any;
  multipleEdit = false;
  budgetProofURLs: any;
  ref: any;
  quickCodeCategoryList:any;

  @ViewChild('ngFYSelect') ngFYSelect: NgSelectComponent | any;
  @ViewChild('ngBudgetTypeSelect') ngBudgetTypeSelect: NgSelectComponent | any;
  @ViewChild('ngRefSelect') ngRefSelect: NgSelectComponent | any;

  constructor( private emsServices: EmsServicesService,
      public dialogService: DialogService,
       public dialogRef: DynamicDialogRef,
       public data: DynamicDialogConfig,
       public messageService: MessageService,
       public sharedService: SharedService,
      public BudgetsService:BudgetsService,
    private datePipe: DatePipe){
     this.accountList = JSON.parse(localStorage.getItem('accountList')!);
     this.accountMappingList = JSON.parse(localStorage.getItem('accountMappingList')!);
     this.quickCodeCategoryList = JSON.parse(localStorage.getItem('category')!);
      this.allCatagory = JSON.parse(localStorage.getItem('categoryMap')!)
      this.sendCatagoryId = this.setId()
      this.getQuickCodeListByCategoryId(this.sendCatagoryId.toString())
    // this.getwarehouse()
    // this.getCustomer()

    this.editTrue =data?.data?.edit
    if(data && data?.data && data?.data?.editData && data?.data?.edit){
      if(data?.data?.editData.length === 1){
        this.EditData = data?.data?.editData[0]
        this.selectCustomer(this.EditData?.mappingId);

        console.log(data?.data)
        this.createForm.patchValue({
        //  expenseName: this.EditData?.expenseName,
        //  expenseCategoryId: this.EditData?.expenseCategoryId,
        //  expenseModeId: this.EditData?.expenseModeId,
        // this.EditData?.zoneId,
        financialYearId:this.EditData?.financialYearId,
        // budgetDate:this.EditData?.budgetDate,
        budgetDate : moment(this.EditData.budgetDate, "DD-MM-YYYY HH:mm:ss Z").toDate(),
        
        warehouseId:this.EditData?.warehouseId,
        // zoneId:this.EditData?.zoneId,
        accountId:this.EditData?.accountId,
        // customerOwned:this.EditData?.customerOwned?.toString(),
        // totalExpenseAmount:this.EditData?.totalExpenseAmount,
        approvedBudget:this.EditData?.approvedBudget,
        budgetTypeId:this.EditData?.budgetTypeId,
        referenceId:this.EditData?.referenceId,
        remarks:this.EditData?.remarks,
        // warehouseTypeId:this.EditData?.warehouseTypeId,
        mappingId:this.EditData?.mappingId,
        // budgetProof:this.EditData?.budgetProof,
        expenseId:this.EditData?.expenseId,
      });
      // this.createForm.controls.budgetProof = this.EditData?.budgetProof.join() 
      this.budgetProofURLs = typeof this.EditData?.budgetProof === 'string' ? this.EditData.budgetProof : '';
      }
      else{
        this.EditData = data?.data?.editData
        this.multipleEdit = true
        this.clearFormValidators()
        this.createForm.reset()
      }
    }
    
  }
  clearFormValidators() {
    Object.keys(this.createForm.controls).forEach((key) => {
      this.createForm.get(key)?.clearValidators();
      this.createForm.get(key)?.updateValueAndValidity();
    });
  }
  setMonth(event:any){
    const value = this.sharedService.formatDate(event)
    this.createForm.controls['budgetDate'].setValue(value)
  }
  selectCustomer(event:any){
    if(event){
      this.accountMappingList.forEach((el:any)=>{
        if(el?.id == event){
          this.createForm.controls.accountId.setValue(el.accountId)
          this.createForm.controls.warehouseId.setValue(el.warehouseId)
          // this.createForm.controls.zoneId.setValue(el.zoneId)
          // this.createForm.controls.warehouseTypeId.setValue(el.warehouseTypeId)
          this.expenseTypeList = el?.expenseAssociated
        }
      })
    }
  }
  addBudget(){
    console.log("add")
  }
  closeDialog(){
    
  }

  setId(): (number | undefined)[] {
    const keys = [
        'zone',
        'warehouseType',
        'financialYear',
        'reference',
        'expenseType',
        'budgetType'
    ];
    return keys.map(key => this.allCatagory?.[key]?.id);
  }
  getQuickCodeListByCategoryId(ids:any) {
    this.emsServices
      .getQuickCodeListByCategoryId(ids)
      .subscribe((data: any) => {
        console.log(data?.responseObject)
        this.zone = data?.responseObject?.zone
        this.budgetType = data?.responseObject?.budgetType
        // this.expenseTypeList = data?.responseObject?.expenseType
        this.financialYear = data?.responseObject?.financialYear;
        const today = new Date();
        const currentYear = today.getFullYear();
        const currentMonth = today.getMonth() + 1;
  
        let financialYear = '';
        if (currentMonth >= 4) {
           financialYear = `${currentYear}-${(currentYear + 1).toString()}`;
          } else {
          financialYear = `${currentYear - 1}-${currentYear.toString()}`;
        }
        const defaultFY = this.financialYear.find((item:any) => item.name === financialYear);
  
        if(!this.editTrue){
          if (defaultFY) {
            this.createForm.get('financialYearId')?.patchValue(defaultFY.id);
          }
        }
        this.referenceList = data?.responseObject?.reference
        this.warehouseTypeList = data?.responseObject?.warehouseType
        
      });
  }


  // submitForm() {
  //   // const formValues = { ...this.createForm.value } as any;;
  //   // if (formValues.budgetDate) {
  //   //   formValues.budgetDate = this.datePipe.transform(formValues.budgetDate, 'dd-MM-yyyy HH:mm:ss Z');
  //   // }
  //   const formValues = { ...this.createForm.value };
  //   if (formValues.budgetDate) {
  //     formValues.budgetDate = this.datePipe.transform(formValues.budgetDate, 'dd-MM-yyyy HH:mm:ss Z');
  //   }
    
  //   let payload: any = {
  //     financialYearId:formValues.financialYearId,
  //     budgetDate:formValues.budgetDate,
  //     warehouseId:formValues.warehouseId,
  //     zoneId:formValues.zoneId,
  //     accountId:formValues.accountId,
  //     customerOwned:formValues.customerOwned,
  //     totalExpenseAmount:formValues.totalExpenseAmount,
  //     approvedBudget:formValues.approvedBudget,
  //     budgetTypeId:formValues.budgetTypeId,
  //     referenceId:formValues.referenceId,
  //     remarks:formValues.remarks,
  //     warehouseTypeId:formValues.warehouseTypeId,
  //     budgetProof:formValues.budgetProof,
  //     expenseTypeId:formValues.expenseTypeId,
  //   };
  //   if (this.editTrue) {
  //     payload.id = this.EditData.id;
  //   }
  //   console.log(payload);
  
  //   if (this.editTrue) {
  //     this.BudgetsService.addOrUpdate(payload).subscribe((data: any) => {
  //     if(data){
  //       this.messageService.add({
  //         severity: 'success',
  //         summary: 'Success',
  //         detail: 'Account updated successfully',
  //       });
  //       this.dialogRef.close(data);
  //     }
  //   });
  //   }else {
  //     this.BudgetsService.addOrUpdate(payload).subscribe((data: any) => {
  //       if(data){
  //         this.messageService.add({
  //           severity: 'success',
  //           summary: 'Success',
  //           detail: 'Account added successfully',
  //         });
  //         this.editTrue = false
  //         this.dialogRef.close(data);
  //       }
  //     });
  //   }
  // }

  submitForm() {
    // const setBudgetProof: string | null = this.budgetProofURLs?.length > 0 ? this.budgetProofURLs?.join(',') : null;
    // this.createForm.controls.budgetProof.setValue(setBudgetProof as any);
    this.createForm.controls.budgetProof.setValue(this.budgetProofURLs);
    
    const formValues: { [key: string]: any } = { ...this.createForm.value };
  console.log(formValues['budgetDate'])
    if (formValues['budgetDate']) {
      formValues['budgetDate'] = this.datePipe.transform(formValues['budgetDate'], 'dd-MM-yyyy HH:mm:ss Z');
    }
  
    if (this.multipleEdit && this.EditData.length > 1) {
      let payloadArray = this.EditData.map((editItem: any) => {
        let filteredPayload: { [key: string]: any } = { 'id': editItem['id'] };
  
        Object.keys(formValues).forEach((key) => {
          if (formValues[key] !== null && formValues[key] !== undefined && formValues[key] !== '') {
            filteredPayload[key] = formValues[key];
          }
        });
        filteredPayload['pendingApproval'] = 'APPROVED';
  
        return filteredPayload;
      });
  
      console.log(payloadArray);
  
      this.BudgetsService.bulkAddOrUpdate(payloadArray).subscribe((data: any) => {
        if (data) {
          this.dialogRef.close(data);
        }
      });
    } else {
      let payload: { [key: string]: any } = {};
  
      Object.keys(formValues).forEach((key) => {
        if (formValues[key] !== null && formValues[key] !== undefined && formValues[key] !== '') {
          payload[key] = formValues[key];
        }
      });
      payload['pendingApproval'] = 'APPROVED';
      
      if (this.editTrue) {
        payload['id'] = this.EditData['id'];
      }
  
      console.log(payload);
  
      this.BudgetsService.addOrUpdate(payload).subscribe((data: any) => {
        if (data) {
          this.dialogRef.close(data);
        }
      });
    }
  }

  selectFile(event: any): void {
    this.selectedFiles = event.target.files;
    this.upload()
  }

  upload(): void {
    this.progress = 0;

    if (this.selectedFiles) {
      const file: File | null = this.selectedFiles.item(0);

      if (file) {
        this.currentFile = file;

        this.emsServices.upload(this.currentFile).subscribe({
          next: (event: any) => {
            if (event.type === HttpEventType.UploadProgress) {
              this.progress = Math.round((100 * event.loaded) / event.total);
              if (this.progress == 100) {
                this.progress = 100;
              }
            } else if (event instanceof HttpResponse) {
              this.message = event.body.message;
              console.log(event.body)
              this.budgetProofURLs = event.body.responseObject
              // this.budgetProofURLs.push(event.body.responseObject)
              // this.createForm.controls.budgetProof.setValue(event.body.responseObject)
              this.progress = 0;
              this.uploadInput.nativeElement.value = null
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Uploaded Successfully',
              });
            }
          },
          error: (err: any) => {
            console.log(err);
            this.progress = 0;
            this.uploadInput.nativeElement.value = null
            if (err.error && err.error.message) {
              this.message = err.error.message;
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: err.error.message,
              });
            } else {
              this.message = 'Could not upload the file!';
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: this.message,
              });
            }

            this.currentFile = undefined;
          },
        });
      }

      this.selectedFiles = undefined;
      }
  }

  removeBudgetProofURLs(item:any){
    this.budgetProofURLs.forEach((el:any,i:any)=>{
      if(el === item){
        this.budgetProofURLs.splice(i,1);
      }
    })
  }

  // create quick code -------------
  create(name:any) {
    document.querySelector('.ng-dropdown-panel')?.classList.remove('ng-select-opened');
    this.ngBudgetTypeSelect.close();
    this.ngFYSelect.close();
    this.ngRefSelect.close();
    const selectedData = [
      {
        categoryId: this.allCatagory[name].id, 
        status:this.allCatagory[name].status
      }
    ]
      this.ref = this.dialogService.open(createQuickCodeComponent, {
        header: 'Add Quick Code',
        data: {
          quickCodeCategoryList: this.quickCodeCategoryList,
          editData : selectedData,
          addFromAnotherComponent: true
        },
        width: '35vw',
        contentStyle: { overflow: 'auto', position: 'top' },
        draggable: true,
      });
      this.ref.onClose.subscribe((data: any) => {
        if(data.responseObject){
          setTimeout(() => {
            this.sendCatagoryId = this.setId()
            this.getQuickCodeListByCategoryId(this.sendCatagoryId.toString())
          }, 500);
        }
      });
    }

}
